<template>
    <div v-common-display>
        <div class="detail-hqsj-jstext" style="width: 87%; margin: 0 auto;">
            国内五档及CME集团、LME、Eurex等境外数据授权是<common-data name="appShortName_12"/>/<common-data name="appShortName_11"/>/<common-data name="appShortName_17"/>的选配模块，请直接购买<common-data name="appShortName_12"/>/<common-data name="appShortName_11"/>/<common-data name="appShortName_17"/>，购买的时候选配一下你需要的行情数据即可。</div>
        <div class="margin-top-sm" style="width: 87%; margin: 0 auto;margin-top:10px;"> <span class="detail-hqsj-text">行情数据列表</span></div>
        <div style="width:65%;margin:0 auto;text-align:right;font-size:14px;color:#8C8B90;margin-top:-10px;">价格单位：元/年/账号</div>
        <table id="tab-gnwd" class="tab-hqsj" cellspacing="0" cellpadding="0" style="clear:both;width:65%;">
            <tbody>
                <!-- <tr>
                    <th rowspan="2" style="width: 12%;" class="tab-th tab-border-right">类别</th>
                    <th rowspan="2" style="width: 55%;" class="tab-th tab-border-right">实时数据授权名称</th>
                    <th colspan="2" class="tab-th tab-border-right">价格</th>
                </tr> -->
                <!-- <tr>
                    <th style="width: 150px;" class="tab-th tab-border-right">非专业用户</th>
                    <th style="width: 150px;" class="tab-th tab-border-right">专业用户</th>
                </tr> -->
                <tr>
                    <td class="tab-wpsj-td" rowspan="36"
                        style="text-align: center;background:#FFEBCC;color: #606060;font-size: 14px;word-wrap: break-word; letter-spacing: 8px;padding-left: 12px;">
                        <strong>境外收费数据</strong></td>
                    <td style="width: 300px;background:#FDF1E1;" rowspan="2" class="tab-wpsj-td tab-title-td padding_small">
                        <strong>CME集团实时数据</strong>
                    </td>
                    <td colspan="2" class="tab-wpsj-td tab-title-td padding_small" style="background:#FDF1E1;">价格</td>
                </tr>
                <tr>
                    <td style="width: 120px;background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">非专业用户
                    </td>
                    <td style="width: 120px;background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">专业用户
                    </td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">芝加哥期货交易所（CBOT）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">芝加哥商品交易所（CME）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">纽约商业交易所（NYMEX）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">纽约商品交易所（COMEX）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">五档 - 芝加哥期货交易所（CBOT）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 1800</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">五档 - 芝加哥商品交易所（CME）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 1800</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">五档 - 纽约商业交易所（NYMEX）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 1800</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color1 padding_l5">五档 - 纽约商品交易所（COMEX）</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 1800</td>
                    <td class="tab-wpsj-td td-hqsj-je color1">+ 12000</td>
                </tr>
                <tr>
                    <td style="background:#FDF1E1;" class="tab-wpsj-td tab-title-td">
                        <strong>Eurex实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格（个人）</td>
                </tr>
                <!-- <tr>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">个人</td>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">公司</td>
                </tr> -->
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">欧洲期货交易所（EUREX）</td>
                    <td colspan="2" class="tab-wpsj-td td-hqsj-je color2">+ 600</td>
                    <!-- <td class="tab-wpsj-td td-hqsj-je color2">+ 7200</td> -->
                </tr>
                <tr>
                    <td style="background:#FDF1E1;" class="tab-wpsj-td tab-title-td padding_small">
                        <strong>ICE实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color3 padding_l5">洲际交易所（ICE）- 美国</td>
                    <td class="tab-wpsj-td td-hqsj-je color3 price_center" colspan="2">+ 16500</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color3 padding_l5">洲际交易所（ICE）- 欧洲商品</td>
                    <td class="tab-wpsj-td td-hqsj-je color3 price_center" colspan="2">+ 16500</td>
                </tr>
                 <tr>
                    <td style="background:#FDF1E1;" rowspan="2" class="tab-wpsj-td tab-title-td">
                        <strong>LME实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">个人</td>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">公司</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">伦敦金属交易所LME电子盘（仅中国大陆、中国香港查看）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color2"><span class="bold_line"></span></td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">伦敦金属交易所LME（全球查看）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2" colspan="2">+ 15000</td>
                </tr>
                <tr>
                    <td style="background:#FDF1E1;" rowspan="2" class="tab-wpsj-td tab-title-td">
                        <strong>OSE实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">个人</td>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">公司</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">大阪交易所（OSE）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 3000</td>
                </tr>
                <tr>
                    <td style="background:#FDF1E1;" rowspan="2" class="tab-wpsj-td tab-title-td">
                        <strong>HKEX期货实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">个人</td>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">公司</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">香港交易所期货（仅中国大陆内查看）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 3000</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">香港交易所期货（全球查看）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2" colspan="2">+ 3000</td>
                </tr>
                <tr>
                    <td style="background:#FDF1E1;" rowspan="2" class="tab-wpsj-td tab-title-td">
                        <strong>HKEX股票实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">个人</td>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">公司</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">香港交易所股票（仅中国大陆内查看）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 1200</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 1800</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">香港交易所股票（全球查看）</td>
                    <td class="tab-wpsj-td td-hqsj-je color2" colspan="2">+ 3000</td>
                </tr>
                
                <tr>
                    <td style="background:#FDF1E1;" rowspan="2" class="tab-wpsj-td tab-title-td">
                        <strong>美国股票实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">非专业用户</td>
                    <td style="background:#FBE5C0;color:#6D5C40;" class="tab-wpsj-td tab-title-td padding_small">专业用户</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color2 padding_l5">美国股票</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 600</td>
                    <td class="tab-wpsj-td td-hqsj-je color2">+ 4200</td>
                </tr>
                <tr>
                    <td style="background:#FDF1E1;" class="tab-wpsj-td tab-title-td padding_small">
                        <strong>其它境外实时数据</strong>
                    </td>
                    <td style="background:#FDF1E1;" colspan="2" class="tab-wpsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color6 padding_l5">伦敦金数据</td>
                    <td class="tab-wpsj-td td-hqsj-je color6 price_center" colspan="2">+ 600</td>
                </tr>
                <tr>
                    <td class="tab-wpsj-td color6 padding_l5">全球外汇</td>
                    <td class="tab-wpsj-td td-hqsj-je color6 price_center" colspan="2">+ 600</td>
                </tr>
                <tr>
                    <td class="tab-hqsj-td tab-border-right" rowspan="8"
                        style="text-align: center;background:#BCDCF5;color: #606060;font-size: 14px;word-wrap: break-word; letter-spacing: 8px;padding-left: 12px;">
                        <strong>境内收费数据</strong></td>
                    <td style="background:#D6EBFC;" class="tab-hqsj-td tab-title-td padding_small">
                        <strong>国内五档数据</strong>
                    </td>
                    <td colspan="2" style="background:#D6EBFC;" class="tab-hqsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td class="tab-hqsj-td tab-border-right color4 padding_l5">LEVEL2 - 大连商品交易所（DCE）</td>
                    <td class="tab-hqsj-td tab-border-right td-hqsj-je color4 price_center" colspan="2">+ 1200</td>
                </tr>
                <tr>
                    <td class="tab-hqsj-td tab-border-right color4 padding_l5">五档 - 大连商品交易所（DCE）</td>
                    <td class="tab-hqsj-td tab-border-right td-hqsj-je color4 price_center" colspan="2">+ 600</td>
                </tr>
                <!-- <tr>
                    <td class="tab-hqsj-td tab-border-right color4 padding_l5">五档 - 金融期货交易所（CFFEX）</td>
                    <td class="tab-hqsj-td tab-border-right td-hqsj-je color4 price_center" colspan="2">+ 1200</td>
                </tr> -->
                <tr>
                    <td class="tab-hqsj-td tab-border-right color4 padding_l5">五档 - 郑州商品交易所（ZCE）</td>
                    <td class="tab-hqsj-td tab-border-right td-hqsj-je color4 price_center" colspan="2">+ 600</td>
                </tr>

                <tr>
                    <td style="background:#D6EBFC;" class="tab-hqsj-td tab-title-td padding_small">
                        <strong>国内实时数据</strong>
                    </td>
                    <td colspan="2" style="background:#D6EBFC;" class="tab-hqsj-td tab-title-td padding_small">价格</td>
                </tr>
                <tr>
                    <td class="tab-hqsj-td tab-border-right color5 padding_l5">上海黄金交易所数据（黄金T+D等）</td>
                    <td class="tab-hqsj-td tab-border-right td-hqsj-je color5 price_center" colspan="2">+ 600</td>
                </tr>
                <!-- <tr>
                    <td class="tab-hqsj-td tab-border-right color5 padding_l5">金融期货交易所（CFFEX）境外查看*</td>
                    <td class="tab-hqsj-td tab-border-right td-hqsj-je color5 price_center" colspan="2">+ 3600</td>
                </tr> -->
            </tbody>
        </table>
        <div class="anno_txt" style="margin-top:20px;">
            * 注：未标注“五档”字样的交易所数据都只提供一档数据。<br>
            <!-- <b>1、</b><span>如有需要在境外查看中金一档数据的用户需按上表价格缴纳数据授权费，免费中金一档数据仅限在中国境内范围内使用；</span> -->
        </div>
        <!-- <div class="anno_txt">
            <b>2、</b><span>未标注“五档”字样的交易所数据都只提供一档数据。</span>
        </div> -->
        <div class="buy_notice" style="font-size: 14px;">
            <div class="gmxz">导购建议</div>
            <p>如果你没有量化交易的需求，购买
                <a href="http://pay.wenhua.com.cn/#/detail/76" target="_blank"
                    style="text-decoration: underline;"><common-data name="appShortName_12"/>的7E个人版</a>（1800元/年/账号）即可，在线购买过程中再选配行情数据。</p>
        </div>
        <div class="buy_msg">
            <div class="buy_title">购买须知</div>
            <p>1、授权账号在同一时间仅能登录一个终端，不可用多个软件同时登录。</p>
            <p>2、电脑配置及网络要求，参见所选<common-data name="appShortName_12"/>/<common-data name="appShortName_11"/>/<common-data name="appShortName_17"/>软件的要求。</p>
        </div>
        <div class="details_gn" style="min-height:0;height:auto;background:white;padding-top:20px">

            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
    }
</script>
<style scoped>
    @import url('./doc.css');

    .buy_msg {
        font-size: 14px;
        width: 87%;
        margin: 0 auto;
        margin-top: 20px;
        color: #656565;
    }

    .buy_msg p {
        padding-left: 5px;
        color: #656565;
    }

    .buy_title {
        position: relative;
        padding-left: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 15px;
    }

    .buy_title::before {
        content: '';
        position: absolute;
        left: 0;
        top: 4px;
        height: 12px;
        width: 3px;
        background: #0C69AF;
    }

    .anno_txt {
        font-size: 13px;
        line-height: 20px;
        width: 65%;
        margin: 0 auto;
        color: #7e7e7e;
        
    }

    .anno_txt b {
        font-weight: normal;
        float: left;
    }

    .anno_txt span {
        overflow: hidden;
        display: block;
    }

    .margin-top-sm {
        margin-top: 10px;
    }

    .detail-hqsj-text::before {
        content: '';
        position: absolute;
        left: 0;
        top: 4px;
        height: 14px;
        width: 3px;
        background: #0C69AF;
    }

    .detail-hqsj-jstext {
        text-indent: 2em;
        color: #656565;
        font-size: 14px;
    }

    .detail-hqsj-text {
        color: #5C5C5C;
        font-size: 15px;
        font-weight: bold;
        position: relative;
        padding-left: 10px;
    }

    .tab-hqsj {
        border-collapse: collapse;
        margin: 0 auto;
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 12px;
    }

    #tab-gnwd th.tab-th {
        background: #d9d9d9;
    }

    .tab-hqsj td,
    .tab-hqsj th {
        border: 1px solid #D4D4D4;
        height: 24px;
        padding: 3px 4px;
    }
    .tab-hqsj td.padding_l5{
        padding-left: 12px;
    }
    .tab-hqsj td.padding_small{
        padding: 0px 4px;
    }
    .tab-th {
        color: #303030;
        text-align: center;
        font-size: 13px;
        background: #f3f3f3;
    }

    .tab-wpsj-td {
        background: #eef9ff;
        color: #666;
    }

    .td-hqsj-je {
        color: #5e1317;
        font-weight: bold;
        text-align: left;
        padding-left: 30px !important;
    }

    .tab-hqsj-td {
        background: #fffeee;
        color: #666;
    }

    .buy_notice {
        border: 1px dashed #E0AB5B;
        background-color: #FEFBF6;
        width: 87%;
        padding: 18px 20px;
        box-sizing: border-box;
        position: relative;
        margin: 0 auto;
        margin-top: 35px;
        color: #796241;
        border-radius: 7px;
        text-indent: 2em;
    }

    .buy_notice a {
        color: #3D8AFF;
    }

    .gmxz {
        width: 78px;
        text-indent: 0;
        height: 25px;
        line-height: 25px;
        background: #E0AB5B;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
        position: absolute;
        left: -1px;
        top: -14px;
        text-align: center;
    }

    .td-hqsj-je {
        color: #5a5a5a;
        font-weight: bold;
        text-align: center;
        padding-left: 0 !important;
    }

    .tab-title-td {
        font-weight: bold;
        text-align: center;
    }

    .color1 {
        background: #fffdfb;
    }

    .color2 {
        background: #fffdfb;
    }

    .color3 {
        background: #fffdfb;
    }

    .color4 {
        background: #F3FBFE;
    }

    .color5 {
        background: #F3FBFE;
    }

    .color6 {
        background: #fffdfb;
    }

    .tab-hqsj td.td-hqsj-je.price_center {
        text-align: left;
        padding-left: 100px !important;
    }

    .bold_line {
        display: inline-block;
        width: 8px;
        height: 2px;
        background-color: #666;
        vertical-align: middle;
    }
</style>